<section class="generic-error">
  <img src="https://assets.zestmoney.in/assets/customers/icons/generic-error.svg" alt="Someting went Wrong" />
  <div class="content">
    <p class="heading">Oh! It is taking longer than expected</p>
    <p class="retry-text">
      Let us get it right this time.
      <br />
      Please try again.
    </p>
  </div>
  <button class="btn zest-btn home-button" (click)="retryClick()">
    Try again
  </button>
</section>